import BaseAPI from "./base/base-api";

class TemplateApi extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Template";
}

export default new TemplateApi();
